import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    list: {
        isPackageLoading: false,
        isSpoolLoading: false,
        spools: [],
        spoolCount: "",
        error: "",
        currentPage: 1,
        pageCount: 0,
        spoolID: "",
        revision: "",
        highlightSpoolState: "",
        shippingDate:"",
        selectedSpools: [],
        toggleAll: false,
        revisionChangesApplied: false,
        isApplied: false,
        confirmDeletePopup: false,
        noOfRevisions: 0,
        spoolBannerUpdated: false,
    },
}

const namespacers = {
    listSpools: createNamespacer("LIST_SPOOLS"),
}

const listReducer = createReducer(initialState.list, {
    [namespacers.listSpools("SET_SPOOLS")]: (state, action) => {
        return {
            ...state,
            spools: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.listSpools("RESET_SELECTED_SPOOLS")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.value
        }
    },
    [namespacers.listSpools("TOGGLE_DELETE_POPUP")]: (state, action) => {
        return {
            ...state,
            confirmDeletePopup: action.payload.value
        }
    },
    [namespacers.listSpools("SET_SPOOLS_COUNT")]: (state, action) => {
        return {
            ...state,
            spoolCount: action.payload.value,
        }
    },
    [namespacers.listSpools("RESET_TOGGLE_ALL")]: (state, action) => {
        return {
            ...state,
            toggleAll: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_IS_APPLIED")]: (state, action) => {
        return {
            ...state,
            isApplied: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_CHANGES_APPLIED")]: (state, action) => {
        return {
            ...state,
            revisionChangesApplied: action.payload.value,
            noOfRevisions: action.payload.noOfRevisions,
            spoolBannerUpdated: action.payload.spoolBannerUpdated,
        }
    },
    [namespacers.listSpools("TOGGLE_ALL_PACKAGES")]: (state, action) => {
        return {
            ...state,
            toggleAll: !state.toggleAll,
            spools: action.payload.newSpools,
            selectedSpools: action.payload.selectedSpoolIds
        }

    },
    [namespacers.listSpools("SET_SELECTED_SPOOLS")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.selectedSpoolIds,
            spools: action.payload.newSpools,
            toggleAll: action.payload.checkedAllStatus
        }

    },

    [namespacers.listSpools("REMOVE_SELECTED_SPOOLS")]: (state, action) => {
        return {
            ...state,
            selectedSpools: action.payload.newSelectedSpoolIds,
            spools: action.payload.newSpools,
            toggleAll: action.payload.checkedAllStatus
        }

    },
    [namespacers.listSpools("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_PACKAGE_LOADING")]: (state, action) => {
        return {
            ...state,
            isPackageLoading: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_SPOOL_LOADING")]: (state, action) => {
        return {
            ...state,
            isSpoolLoading: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_SPOOL")]: (state, action) => {
        return {
            ...state,
            spoolID: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_REVISION")]: (state, action) => {
        return {
            ...state,
            revision: action.payload.value,
        }
    },
    [namespacers.listSpools("HIGHLIGHT_SPOOL")]: (state, action) => {
        return {
            ...state,
            highlightSpoolState: action.payload.highlightSpool,
        }
    },
    [namespacers.listSpools("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            packageID: 'package_ID',
            projectName: 'project_name',
            // shippingDate: 'required_date'
        }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey]
                }]
            })
        )

        return {
            ...state,
            ...loadedFields,
            shippingDate: action.payload.shippingDate
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;